module.exports = __webpack_public_path__ + "static/media/my-group.93a94521.svg";